import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAnsysComponent } from './simple-icons-ansys.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAnsysComponent ],
    exports:      [ SimpleIconsAnsysComponent ],
    bootstrap:    []
})
export class SimpleIconsAnsysModule {}
